import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { TablaVacia } from "../../../../components/mensajes/Mensajes";

import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Ripple } from 'primereact/ripple';
import { Button } from 'primereact/button';
import TituloComponent from '../../../../genericos/TituloComponent';
import BotonesPrincipal from '../Botones/BotonesPrincipal';

const TablaUsuarios = ({ openNew, confirmDeleteSelected, dt, products, selectedProducts, setSelectedProducts, actionBodyTemplate }) => {
    const [currentPage, setCurrentPage] = useState(1)
    const [first1, setFirst1] = useState(0);
    const [rows1, setRows1] = useState(5);
    const [pageInputTooltip, setPageInputTooltip] = useState('Presiona \'Enter\' key para ir a esta pagina.')

    const onCustomPage1 = (event) => {
        setFirst1(event.first);
        setRows1(event.rows);
        setCurrentPage(event.page + 1);
    }

    const onPageInputKeyDown = (event, options) => {
        if (event.key === 'Enter') {
            const page = parseInt(currentPage);
            if (page < 1 || page > options.totalPages) {
                setPageInputTooltip(`El valor debe de estar entre 1 y ${options.totalPages}.`);
            }
            else {
                const first = currentPage ? options.rows * (page - 1) : 0;
                setFirst1(first);
                setPageInputTooltip('Presiona \'Enter\' key para ir a esta pagina.');
            }
        }
    }

    const onPageInputChange = (event) => {
        setCurrentPage(event.target.value);
    }

    const template1 = {

        layout: 'PrevPageLink PageLinks NextPageLink RowsPerPageDropdown CurrentPageReport LastPage',

        'PrevPageLink': (options) => {
            return (
                <div className="flex-wrap w-full text-center md:flex md:w-auto md:text-right">
                    <div className="mt-3">
                        <Button icon="pi pi-angle-double-left" onClick={goFirst} style={{ height: '10px' }} />
                    </div>
                    <div>
                        <button type="button" className={options.className} onClick={options.onClick} disabled={options.disabled}>
                            <span className="p-3">Previo</span>
                            <Ripple />
                        </button>
                    </div>
                </div>
            )
        },

        'NextPageLink': (options) => {
            return (
                <div className="w-full md:w-auto text-center">
                    <button type="button" className={options.className} onClick={options.onClick} disabled={options.disabled}>
                        <span className="p-3">Siguiente</span>
                        <Ripple />
                    </button>
                </div>
            )
        },

        'PageLinks': (options) => {
            if ((options.view.startPage === options.page && options.view.startPage !== 0) || (options.view.endPage === options.page && options.page + 1 !== options.totalPages)) {
                const className = classNames(options.className, { 'p-disabled': true });
                return <span className={className} style={{ userSelect: 'none' }}>...</span>;
            }
            return (
                <>
                    <button type="button" className={options.className} onClick={options.onClick}>
                        {options.page + 1}
                        <Ripple />
                    </button>
                </>
            )
        },

        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 25, value: 25 },
            ];
            return (
                <div className='text-center w-full md:w-auto'>
                    <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </div>
            );
        },

        'CurrentPageReport': (options) => {
            return (
                <div className="mt-3 md:mt-3 md:flex">
                    <div className="md:flex">
                        <p className="w-full md:w-auto">
                            <span className="mx-3" style={{ color: 'var(--text-color)', userSelect: 'none' }}>
                                Ir a <InputText size="2" className="ml-1" value={currentPage} tooltip={pageInputTooltip}
                                    onKeyDown={(e) => onPageInputKeyDown(e, options)} onChange={onPageInputChange} />
                            </span>
                        </p>
                        <p className="w-full md:w-auto md:mt-3 text-center mb-2 md:mb-0">
                            Página {options.currentPage} de {options.totalPages}
                        </p>
                    </div>
                    <div className="mx-3 md:mt-3 text-center">
                        <Button icon="pi pi-angle-double-right" onClick={() => goEnd(options.totalPages, options.rows)} style={{ height: '10px' }} />
                    </div>
                </div>
            )
        },
    };

    const goEnd = (numPage, rows) => {
        const first = rows * (numPage - 1)
        setFirst1(first);
        setCurrentPage(numPage);
    }

    const goFirst = () => {
        setFirst1(0);
        setCurrentPage(1);
    }

    const [datos, setDatos] = useState([])
    useEffect(() => {
        console.log(products)
        if (products.length > 0) {
            const registros = products.map((e) => {
                e.fechaCreacion = e.fechaCreacion ? e.fechaCreacion.substring(0, 10): e.fechaCreacion = ""; 
                return e
            })
            setDatos(registros)
        }
    }, [products])
    //--------------------| Valor que regresara |--------------------
    return (
        <div className="card">
            <TituloComponent titulo='Usuarios' />
            {/* <Toolbar className="mb-4" left={BotonesCabezal} right={ExportarRegistros} /> */}
            <BotonesPrincipal
                openNew={openNew} products={products}
                confirmDeleteSelected={confirmDeleteSelected} selectedProducts={selectedProducts}
            />
            {products.length > 0 ? (
                <DataTable
                    ref={dt}
                    value={datos}
                    selection={selectedProducts}
                    onSelectionChange={(e) => setSelectedProducts(e.value)}
                    paginator
                    paginatorTemplate={template1}
                    first={first1} rows={rows1} onPage={onCustomPage1}

                    showGridlines
                    globalFilterFields={['id', 'linea', 'area']}
                    emptyMessage="No se encontraron resultados."
                    responsiveLayout="scroll"
                    filterDisplay="row"
                >
                    <Column selectionMode="multiple" headerStyle={{ width: "5%", minWidth: '3rem' }} exportable={false} />
                    <Column align={"center"} field="nombreCompleto" header="Nombre Completo" sortable filter filterPlaceholder="Buscar" style={{ minWidth: '15rem', textAlign: 'center' }} />
                    <Column align={"center"} field="rol" header="Rol" sortable filter filterPlaceholder="Buscar" style={{ minWidth: '10rem', textAlign: 'center' }} />
                    <Column align={"center"} field="usuario" header="Usuario" sortable filter filterPlaceholder="Buscar" style={{ minWidth: '10rem', textAlign: 'center' }} />
                    <Column align={"center"} field="email" header="Email usuario" sortable filter filterPlaceholder="Buscar" style={{ minWidth: '15rem', textAlign: 'center' }} />
                    <Column align={"center"} field="estatus" header="Estatus" sortable filter filterPlaceholder="Buscar" style={{ minWidth: '10rem', textAlign: 'center' }}/>
                    <Column align={"center"} field="creadoPor" header="Creado por" sortable filter filterPlaceholder="Buscar" style={{ minWidth: '10rem', textAlign: 'center' }} />
                    <Column align={"center"} field="fechaCreacion" header="Fecha de creación" sortable filter filterPlaceholder="Buscar"  style={{ minWidth: '10rem', textAlign: 'center' }} />
                    <Column align={"center"} header="Editar" body={actionBodyTemplate} exportable={false} style={{ minWidth: "10rem", textAlign: "center" }} />
                </DataTable>
            ) : (
                <TablaVacia texto='usuarios' />
            )}
        </div>
    )
}

export default TablaUsuarios
